export { default } from "./icon";
